import { type FC } from 'react'
import { useClearRefinements, useStats } from 'react-instantsearch'
import { FormattedMessage } from 'react-intl'

import { Button, type DialogProps } from 'base-ui'

export const ProductSearchRefinementsDialogButtons: FC<
  Pick<DialogProps, 'onClose'>
> = ({ onClose }) => {
  const { nbHits } = useStats()
  const { canRefine, refine } = useClearRefinements()

  return (
    <div className="sticky bottom-0 flex flex-col gap-4 p-4">
      <Button
        data-qa-id={
          canRefine
            ? 'form-refinement-list-dialog-apply-filters'
            : 'form-refinement-list-dialog-close-product-filter'
        }
        onClick={() => {
          onClose?.({}, 'backdropClick')
        }}
      >
        {canRefine ? (
          <FormattedMessage
            id="general.label.showResults"
            values={{
              count: nbHits,
            }}
          />
        ) : (
          <FormattedMessage id="general.link.label.close" />
        )}
      </Button>

      <Button
        data-qa-id="form-refinement-list-dialog-clear-filters"
        disabled={!canRefine}
        onClick={refine}
      >
        <FormattedMessage id="general.label.clearFilters" />
      </Button>
    </div>
  )
}
